import React from "react";

import Hero from "../../Component/Home/Hero";
import About from "../../Component/Home/About";
import Services from "../../Component/Home/Services";
import Product from "../../Component/Home/Product";
import WhyChoose from "../../Component/Home/WhyChoose";
import Contact from "../../Component/Home/Contact";
// import Footer from "../../Common/";

const Homepage = () => {
  return (
    <>
      {/* HOME */}
      <section id="home">
        <Hero />
      </section>

      {/* ABOUT */}
      <section id="about">
        <About />
      </section>

      {/* SERVICES */}
      <section id="services">
        <Services />
      </section>

      {/* PRODUCTS */}
      <section id="products">
        <Product />
      </section>

      {/* WHY CHOOSE */}
      <section id="whychoose">
        <WhyChoose />
      </section>

      {/* CONTACT */}
      <section id="contact">
        <Contact />
      </section>

      {/* FOOTER */}
      {/* <Footer /> */}
    </>
  );
};

export default Homepage;